module.exports = __webpack_public_path__ + "img/三星高级大师@2x.112c39aa.png";